import { formatCpfAndCnpj } from 'v2/resources/utils/formatCpfAndCpnj';
import formatPhoneView from 'v2/resources/utils/formatPhone';
import { useQueryUsers } from 'v2/resources/hooks/services/users';
import { IDataTable } from '../types';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { IGetUsersResponse } from 'v2/resources/types/users';
import { useAppSelector } from 'v2/resources/hooks/useAppSelector';

const useUsers = () => {
  const navigate = useHistory();
  const route = navigate.location;

  const { nameProperty } = useAppSelector((state) => state.nameProperty);
  const [valueInputSearch, setValueInputSearch] = useState('');

  const onChangeInputSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValueInputSearch(e.target.value);
  };

  const refresh = (route?.state as { refresh?: boolean })?.refresh;

  const { data: dataUsers, isLoading } = useQueryUsers(!!refresh, nameProperty);

  const formattedData: IDataTable =
    dataUsers?.map(({ id, name, email, cellphone, cpfCnpj, active }) => [
      id,
      name || 'Não informado',
      email || 'Não informado',
      cellphone ? formatPhoneView(cellphone) : 'Não informado',
      cpfCnpj ? formatCpfAndCnpj(cpfCnpj) : 'Não informado',
      active,
    ]) ?? [];

  const formattedDataFiltered = formattedData.filter((item) =>
    String(item[1]).toLowerCase().includes(valueInputSearch.toLowerCase())
  );

  const data = valueInputSearch ? formattedDataFiltered : formattedData;
  const handleClickOption = (
    value: string | number | boolean | React.ReactNode
  ) => {
    if (typeof value === 'number') {
      const id = formattedData[value][0];

      const user =
        dataUsers!.find((item) => item.id === id) ?? ({} as IGetUsersResponse);

      navigate.push(`user/${id}`, { user });
    }
  };

  const handleNavigateCreateUser = () => {
    navigate.push(`user`);
  };
  return {
    data,
    valueInputSearch,
    isLoading,
    handleClickOption,
    onChangeInputSearch,
    handleNavigateCreateUser,
  };
};

export default useUsers;
